'use strict';

/**
 * Amount
 * */


export class _Amount {
	
	constructor(options) {

		this.input = options.container.querySelector(`.js-order-form-item-amount`);
		this.incrementControl = options.container.querySelector(`.js-amount-inc`);
		this.decrementControl = options.container.querySelector(`.js-amount-dec`);
		
		
		
		
		//Constants
		this.STEP = 1;
		this.MIN_VALUE = 0;
		this.MAX_VALUE = 500;
		
		this.value = this.MIN_VALUE;
		
		//stopImmediatePropagation потому что в all.js некорректным селектором навешано событие, наследуемое с меню.
		
		this.incrementControl.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			this.increment();
			options.callback.calculate(this.value);
		});
		
		this.decrementControl.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			this.decrement();
			options.callback.calculate(this.value);
		});
		
		return this;
		
	}	
	
	decrement() {
		let value = this.value;
		
		if (isNaN(value) || value < this.MIN_VALUE) {
			value = this.MIN_VALUE;
		}
		if (value > this.MIN_VALUE) {
			value = value - this.STEP;
		}
		
		this.value = value;
	}
	
	increment() {		
		let value = this.value;
		
		if (isNaN(value) || value < this.MIN_VALUE) {
			value = this.MIN_VALUE;
		}
		value += this.STEP;
		if (isNaN(value) || value >= this.MAX_VALUE) {
			value = this.MAX_VALUE;
		}
		
		this.value = value;
	}
		
            
	
	
	get value() {
		return Number(this.input.value);
	}
	
	set value(value) {
		this.input.value = value;
	}
}


